<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>售后管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: pageUp.path }">{{pageUp.name}}</el-breadcrumb-item>
      <el-breadcrumb-item>售后订单编辑</el-breadcrumb-item>
    </el-breadcrumb>
    <dev>
      <el-form ref="form" :model="orderInfo" :rules="editOrderFormRules" label-width="100px" size="mini">
        <el-row>
          <el-col :span="4">
            <el-form-item :label="orderInfo.pushComCode !== null && orderInfo.pushComCode !== 0 ? '外包订单状态' : '订单状态'">
              <div v-if="orderInfo.orderStatus == '预备售后'">
                <el-select v-model="orderInfo.orderStatus" placeholder="请选择订单状态" :disabled="!pagePermissionObj.modifOrderStatus">
                  <el-option label="预备售后" value="预备售后"></el-option>
                  <el-option label="提交售后" value="提交售后"></el-option>
                </el-select>
              </div>
              <div v-if="orderInfo.orderStatus !== '预备售后'">
                <el-select v-model="orderInfo.orderStatus" placeholder="请选择订单状态" :disabled="(orderInfo.pushComCode !== null && orderInfo.pushComCode !== 0 && orderInfo.receiverComCode != comCode) || (!pagePermissionObj.modifOrderStatus)">
                  <el-option label="预备售后" value="预备售后"></el-option>
                  <el-option label="提交售后" value="提交售后"></el-option>
                  <el-option label="受理订单" value="受理订单"></el-option>
                  <el-option label="报价完成" value="报价完成"></el-option>
                  <el-option label="等待生产" value="等待生产"></el-option>
                  <el-option label="售后生产开始" value="售后生产开始"></el-option>
                  <el-option label="售后生产完成" value="售后生产完成"></el-option>
                  <el-option label="完结售后" value="完结售后"></el-option>
                  <el-option label="运输外包" value="运输外包"></el-option>
                  <el-option label="异常订单" value="异常订单"></el-option>
                  <el-option label="订单外包" value="订单外包"></el-option>
                  <el-option label="废弃订单" value="废弃订单"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="orderNo" label="订单编号" width="120%">
              <el-input v-model="orderInfo.orderNo" style="width: 100%;" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="接单时间">
              <el-date-picker
                v-model="orderInfo.orderDateTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                disabled>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="margin-left: 2%">
            <el-form-item label="接单客服">
              <el-input v-model="orderInfo.orderReceivPerson" style="width: 90%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="margin-left: -2%">
          <el-form-item label="开单员">
            <el-input v-model="orderInfo.billingPerson" style="width: 90%;" disabled></el-input>
          </el-form-item>
          </el-col>
          
          <el-col :span="2" style="margin-left: 2%">
            <el-button type="primary" @click="onSubmit" v-if="pageUp.name !== '售后订单报价'">保存修改</el-button>
            <el-button type="primary" @click="modifyOrder" v-if="pageUp.name === '售后订单报价'">推送报价</el-button>
          </el-col>
          
          <el-col :span="2">
            <el-button type="info" @click="orderInfoPrint">打印订单</el-button>
          </el-col>
          
          
        </el-row>
        
        <el-row>
          <el-col :span="4"><p class="text_l">基本信息</p></el-col>
        </el-row>
        
        <el-row>
          <el-col :span="6">
            <el-form-item prop="shop" label="订货店铺">
              <el-input v-model="orderInfo.shop" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="shippingClerk" label="发货员">
              <el-input v-model="orderInfo.shippingClerk" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="shopPhone" label="店铺电话">
              <el-input v-model="orderInfo.shopPhone" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="shipAddr" label="发货地址">
              <el-input v-model="orderInfo.shipAddr" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="6">
            <el-form-item prop="customerId" label="客户ID">
              <el-input v-model="orderInfo.customerId" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="customerName" label="客户姓名">
              <el-input v-model="orderInfo.customerName" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="customerPhone" label="客户电话">
              <el-input v-model.trim="orderInfo.customerPhone" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="customerAddr" label="收货地址">
              <el-input v-model="orderInfo.customerAddr" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="4"><p class="text_l">订单信息</p></el-col>
        </el-row>
        
        <el-row>
          <el-col :span="4">
            <el-form-item label="订单类型" style="width: 90%;">
              <el-select v-model="orderInfo.orderType" placeholder="请选择订单类型" style="width: 90%;">
                <el-option label="普通订单" value="普通订单"></el-option>
                <el-option label="加急订单" value="加急订单"></el-option>
                <el-option label="出库订单" value="出库订单"></el-option>
                <el-option label="库存订单" value="库存订单"></el-option>
                <el-option label="返工订单" value="返工订单"></el-option>
                <el-option label="退货订单" value="退货订单"></el-option>
                <el-option label="无需补发" value="无需补发"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="duty" label="责任界定" style="width: 90%;">
              <el-select v-model="orderInfo.duty" placeholder="请选择">
                <el-option label="工厂原因" value="工厂原因"></el-option>
                <el-option label="物流原因" value="物流原因"></el-option>
                <el-option label="客户原因" value="客户原因"></el-option>
                <el-option label="客服原因" value="客服原因"></el-option>
                <el-option label="供应商原因" value="供应商原因"></el-option>
                <el-option label="售后质保" value="售后质保"></el-option>
                <el-option label="物流工厂共同" value="物流工厂共同"></el-option>
                <el-option label="物流客户共同" value="物流客户共同"></el-option>
                <el-option label="物流客服共同" value="物流客服共同"></el-option>
                <el-option label="工厂客服共同" value="工厂客服共同"></el-option>
                <el-option label="工厂客户共同" value="工厂客户共同"></el-option>
                <el-option label="客户客服共同" value="客户客服共同"></el-option>
                <el-option label="其他原因" value="其他原因"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="deliveryDate" label="发货日期">
              <el-date-picker
                :picker-options='pickerOptions'
                v-model="orderInfo.deliveryDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择发货日期"
                style="width: 93%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="生产日期" prop="productionDate">
              <el-date-picker
                v-model="orderInfo.productionDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择生产日期"
                style="width: 93%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="logisticsMode" label="发货方式">
              <el-select v-model="orderInfo.logisticsMode" placeholder="请选择" style="width: 90%;">
                <el-option label="送货安装" value="送货安装"></el-option>
                <el-option label="送货楼下" value="送货楼下"></el-option>
                <el-option label="送货楼上" value="送货楼上"></el-option>
                <el-option label="客户自提" value="客户自提"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="orderInfo.outsideProduct" style="margin-left: 20%;">外采产品</el-checkbox>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="4"><p class="text_l">产品信息</p></el-col>
        </el-row>
        
        <el-row>
          <el-col :span="4">
            <el-form-item prop="productName" label="产品名称">
              <el-input v-model="orderInfo.productName" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="colour" label="颜色">
              <el-input v-model="orderInfo.colour" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="speModel" label="规格型号">
              <el-input v-model="orderInfo.speModel" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="quantity" label="套数">
              <el-input v-model="orderInfo.quantity" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="sheetMaterial" label="板材材料">
              <el-select v-model="orderInfo.sheetMaterial" placeholder="请选择" style="width: 80%;">
                <el-option label="实木多层板" value="实木多层板"></el-option>
                <el-option label="实木颗粒板" value="实木颗粒板"></el-option>
                <el-option label="实木颗粒板和多层板混合" value="实木颗粒板和多层板混合"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="板件数量">
              <el-input v-model="orderInfo.plateNum" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          
          <el-col :span="4">
            <el-form-item prop="plateUnitPrice" label="板件单价">
              <el-input v-model="orderInfo.plateUnitPrice " style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="cabinetCost" label="柜体费用">
              <el-input v-model="orderInfo.cabinetCost" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="metalsCost" label="五金费用">
              <el-input v-model="orderInfo.metalsCost" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="outsideProductCost" label="外采费用">
              <el-input v-model="orderInfo.outsideProductCost" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="installCost" label="安装费用">
              <el-input v-model="orderInfo.installCost" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="packCost" label="物流费用">
              <el-input v-model="orderInfo.packCost" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="4">
            <el-form-item prop="subjoinCost" label="附加费">
              <el-input v-model="orderInfo.subjoinCost " style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="factoryTotalMoney" label="工厂费用合计">
              <el-input v-model="orderInfo.factoryTotalMoney " style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="cabinetArea" label="柜体面积">
              <el-input v-model="orderInfo.cabinetArea" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="doorPlankArea" label="门板面积">
              <el-input v-model="orderInfo.doorPlankArea" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="mirrorCushionArea" label="镜子垫子面积">
              <el-input v-model="orderInfo.mirrorCushionArea" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="payTime" label="付款时间">
              <el-date-picker
                v-model="orderInfo.payTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择付款时间"
                style="width: 80%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="4">
            <el-form-item label="提货电话">
              <el-input v-model="orderInfo.pickUpGoodsPhone" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="packingRequirements" label="包装要求">
              <el-select v-model="orderInfo.packingRequirements" placeholder="请选择" style="width: 80%;">
               <el-option label="纸箱" value="纸箱"></el-option>
               <el-option label="木架" value="木架"></el-option>
               <el-option label="易碎物木框+纸箱" value="易碎物木框+纸箱"></el-option>
               <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="打包数">
              <el-input v-model="orderInfo.boxNum" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="打框件数">
              <el-input v-model="orderInfo.woodNum" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
           <el-form-item label="库存数">
             <el-input v-model="orderInfo.inventory" style="width: 80%;"></el-input>
           </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="installRequirements" label="安装要求">
              <el-input v-model="orderInfo.installRequirements" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item prop="doorCost" label="门板费用">
              <el-input v-model="orderInfo.doorCost" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="mirrorCushionCost" label="镜子垫子费用">
              <el-input v-model="orderInfo.mirrorCushionCost" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="unitPricePelletPlate" label="颗粒柜体单价">
              <el-input v-model="orderInfo.unitPricePelletPlate" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="unitPriceMultilayerBoard" label="多层柜体单价">
              <el-input v-model="orderInfo.unitPriceMultilayerBoard" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="particulateCabinetCost" label="颗粒柜体费用">
              <el-input v-model="orderInfo.particulateCabinetCost" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="multiLayerCabinetCost" label="多层柜体费用">
              <el-input v-model="orderInfo.multiLayerCabinetCost" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="4">
            <el-form-item prop="particulateCabinetArea" label="颗粒柜体面积">
              <el-input v-model="orderInfo.particulateCabinetArea" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="multiLayerCabinetArea" label="多层柜体面积">
              <el-input v-model="orderInfo.multiLayerCabinetArea" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="fillPlateArea" label="补件面积">
              <el-input v-model="orderInfo.fillPlateArea" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="patchMirrorCushionArea" label="补件镜子垫子面积">
              <el-input v-model="orderInfo.patchMirrorCushionArea" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="doorTwoCost" label="二次上门费用">
              <el-input v-model="orderInfo.doorTwoCost" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
           <el-form-item prop="patchPartsCost" label="补件成本费用">
             <el-input v-model="orderInfo.patchPartsCost" style="width: 80%;"></el-input>
           </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="4">
            <el-form-item prop="toEstimateTheFreight" label="估算运费">
              <el-input v-model="orderInfo.toEstimateTheFreight" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <dev v-if="orderInfo.receiverComCode == comCode">
            <el-col :span="4">
            <el-form-item prop="processStatus" label="最新完成的工序编号">
              <el-input type="number" v-model="orderInfo.processStatus" style="width: 80%;" :disabled="userType != 1"></el-input>
            </el-form-item>
          </el-col>
          </dev>
          <dev v-if="orderInfo.receiverComCode != comCode">
            <el-col :span="4">
              <el-form-item prop="totalMoney" label="订单金额">
                <el-input v-model="orderInfo.totalMoney" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
             <el-form-item label="付款方式">
               <el-select v-model="orderInfo.paymentMethod" placeholder="请选择" style="width: 80%;">
                 <el-option label="现金" value="现金"></el-option>
                 <el-option label="月结" value="月结"></el-option>
                 <el-option label="发货前付" value="发货前付"></el-option>
                 <el-option label="发货后付" value="发货后付"></el-option>
               </el-select>
             </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="prepay" label="预付">
                <el-input v-model="orderInfo.prepay" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="monthBond" label="月结">
                <el-input v-model="orderInfo.monthBond" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="sreason" label="售后原因">
                <el-input v-model="orderInfo.sreason" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
          </dev>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item prop="sokReason" label="赔付金额">
              <el-input type="textarea" v-model="orderInfo.sokReason" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="备注" width="200%" show-overflow-tooltip=false>
              <el-input type="textarea" v-model="orderInfo.remarks" style="width: 100%;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="margin-left: 2%;">
            <el-button type="primary" @click="onSubmit" v-if="pageUp.name !== '售后订单报价'" size="mini">保存修改</el-button>
            <el-button type="primary" @click="modifyOrder" v-if="pageUp.name === '售后订单报价'" size="mini">推送报价</el-button>
          </el-col>
          
          <el-col :span="2">
            <el-button type="info" @click="orderInfoPrint" size="mini">打印订单</el-button>
          </el-col>
          
          <el-col :span="2">
            <el-button type="success" @click="subAudit" size="mini" v-if="orderInfo.orderStatus === '预备订单'">提交审核</el-button>
          </el-col>
          
          <el-col :span="3" style="margin-left: 6%;">
            <el-upload
              action="/api/file/upload-excel"
              :on-success="uploadExcelSuccess"
              :headers="myHeaders"
              :show-file-list="false"
              multiple>
              <el-button size="small" type="primary">点击上传Excel文件</el-button>
              <div slot="tip" class="el-upload__tip">只支持xls/xlsx文件，不超过20MB</div>
            </el-upload>
          </el-col>
          <el-col :span="2" style="margin-left: 2%;">
            <a :href="orderInfo.excelFileUrl">下载Excel文件</a>
          </el-col>
        </el-row>
        
        <el-row style="margin-top: 0%;">
          
          <el-col :span="4">
            <el-form-item>
              <el-upload
                action="/api/file/upload"
                :on-success="uploadImageSuccess"
                :headers="myHeaders"
                :show-file-list="false"
                multiple>
                <el-button size="small" type="primary">点击上传图片</el-button>
                <div slot="tip" class="el-upload__tip">只支持jpg/png文件，不超过500kb</div>
              </el-upload>
            </el-form-item>
          </el-col>
          
          <draggable v-model="orderImageFileInfoList" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group type="transition">
              <dev style="margin-left: 1%;" v-for="item in orderImageFileInfoList" :key="item" class="item">
                <el-image
                    style="width: 60px; height: 60px"
                    :src="item.fileUrl" 
                    :preview-src-list="[item.fileUrl]">
                </el-image>
                <el-button @click="delImage(item.fileUrl)" style="color: red;" size="mini">删除</el-button>
              </dev>
            </transition-group>
          </draggable>
          
        </el-row>
        
        <div v-if="false">
          <el-row>
            <el-col :span="12"><p style="text-align: right;font-weight: bold;">部件清单</p></el-col>
            <el-col :span="2">
              <el-button type="text" size="mini"  style="margin-top: 10%;margin-bottom: 0%; color: blue;margin-left: 10%;" @click="addParts">新增部件+</el-button>
            </el-col>
          </el-row>
          
          <el-row>
            <el-col :span="1"><center class="text">序号</center></el-col>
            <el-col :span="2"><center class="text">部件条码</center></el-col>
            <el-col :span="2"><center class="text">部件名称</center></el-col>
            <el-col :span="2"><center class="text">部件数量</center></el-col>
            <el-col :span="2"><center class="text">部件类型</center></el-col>
            <el-col :span="2"><center class="text">板件面积</center></el-col>
            <el-col :span="2"><center class="text">部件规格</center></el-col>
            <el-col :span="2"><center class="text">作业序号</center></el-col>
            <el-col :span="2"><center class="text">材料名称</center></el-col>
            <el-col :span="2"><center class="text">开料图</center></el-col>
            <el-col :span="3"><center class="text">备注</center></el-col>
            <el-col :span="1"><center class="text" style="margin-left: -25%">操作</center></el-col>
          </el-row>
          
          <div v-for="(partsInfo,i) in partsList" v-bind:key="partsInfo.partsCode">
            <el-row>
              <el-col :span="1">
                  <center class="text" style="color: #55aaff;margin-top: 4%;">{{i+1}}</center>
              </el-col>
              <el-col :span="2">
                  <input v-model="partsInfo.partsCode" style="width: 80%;margin-left: 10%;" disabled>
              </el-col>
              <el-col :span="2">
                <input v-model="partsInfo.partsName" style="width: 80%;margin-left: 10%;">
              </el-col>
              <el-col :span="2">
                <input v-model="partsInfo.partsNum" style="width: 80%;margin-left: 10%;">
              </el-col>
              <el-col :span="2">
                  <select v-model="partsInfo.partsType" style="width: 80%;margin-left: 10%;">
                    <option value="柜体">柜体</option>
                    <option value="五金">五金</option>
                    <option value="外采">外采</option>
                  </select>
              </el-col>
              <el-col :span="2">
                <input v-model="partsInfo.plateArea" style="width: 80%;margin-left: 10%;">
              </el-col>
              <el-col :span="2">
                <input v-model="partsInfo.partsSpe" style="width: 80%;margin-left: 10%;">
              </el-col>
              <el-col :span="2">
                <input v-model="partsInfo.operationNum" style="width: 80%;margin-left: 10%;">
              </el-col>
              <el-col :span="2">
                <input v-model="partsInfo.materialsName" style="width: 80%;margin-left: 10%;">
              </el-col>
              <el-col :span="2">
                <input v-model="partsInfo.cuttingMap" style="width: 80%;margin-left: 10%;">
              </el-col>
              <el-col :span="3">
                <input v-model="partsInfo.textarea" style="width: 80%;margin-left: 10%;">
              </el-col>
              <el-col :span="1">
                <el-button type="text" size="mini"  style="margin-top: -10%;margin-bottom: -10%; color: forestgreen;margin-left: 20%;" @click="editParts(i)">保存修改</el-button>
              </el-col>
              <el-col :span="1">
                <el-button type="text" size="mini"  style="margin-top: -10%;margin-bottom: -10%; color: red;margin-left: 20%;" @click="delParts(i)">删除</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
		<!-- <div>
			<el-row>
			<el-col	:span="12"><p style="text-align: right;font-weight: bold;">工厂操作清单</p></el-col>
				<el-col :span="2">
				<el-button type="text" size="mini"  style="margin-top: 10%;margin-bottom: 0%; color: blue;margin-left: 10%;" @click="addFactoryOperation">新增操作+</el-button>
			</el-col>
			</el-row>
			<el-row>
				<el-col :span="1"><center class="text">序号</center></el-col>
				<el-col :span="2"><center class="text">板件名称</center></el-col>
				<el-col :span="2"><center class="text">长/高</center></el-col>
				<el-col :span="2"><center class="text">宽/深</center></el-col>
				<el-col :span="2"><center class="text">厚度</center></el-col>
				<el-col :span="1"><center class="text">数量</center></el-col>
				<el-col :span="2"><center class="text">纹理</center></el-col>
				<el-col :span="2"><center class="text">板材</center></el-col>
				<el-col :span="1"><center class="text">板材单位</center></el-col>
				<el-col :span="2"><center class="text">封边</center></el-col>
				<el-col :span="1"><center class="text">封边单位</center></el-col>
				<el-col :span="3"><center class="text">工序签字</center></el-col>
				<el-col :span="1"><center class="text" style="margin-left: -25%">操作</center></el-col>
			</el-row>
			<div v-for="(factoryOperationInfo,i) in factoryOperationList" v-bind:key="factoryOperationInfo.id">
				<el-row>
					<el-col :span="1">
						<center class="text" style="color: #55aaff;margin-top: 4%;">{{i+1}}</center>
					</el-col>
					<el-col :span="2">
						<input v-model="factoryOperationInfo.plateName" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="2">
						<input v-model="factoryOperationInfo.length" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="2">
						<input v-model="factoryOperationInfo.width" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="2">
						<input v-model="factoryOperationInfo.thick" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="1">
						<input v-model="factoryOperationInfo.number" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="2">
						<input v-model="factoryOperationInfo.texture" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="2">
						<input v-model="factoryOperationInfo.board" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="1">
						<input v-model="factoryOperationInfo.boardUnit" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="2">
						<input v-model="factoryOperationInfo.banding" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="1">
						<input v-model="factoryOperationInfo.bandingUnit" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="3">
						<input v-model="factoryOperationInfo.processSign" style="width: 80%;margin-left: 10%;" >
					</el-col>
					<el-col :span="1">
						<el-button type="text" size="mini"  style="margin-top: -10%;margin-bottom: -10%; color: forestgreen;margin-left: 20%;"  >保存修改</el-button>
					</el-col>
					<el-col :span="1">
						<el-button type="text" size="mini"  style="margin-top: -10%;margin-bottom: -10%; color: red;margin-left: 20%;" @click="deleteFactoryOperation(i)">删除</el-button>
					</el-col>
				</el-row>
			</div>
		</div> -->
		</el-form>
    </dev>
    
    <dev>
      <!-- 修改原因 -->
      <el-dialog title="修改原因填写" :visible.sync="modifyDialogVisible" width="40%">
        <el-form ref="modifyReasonForm" :rules="modifyReasonFormRules" :model="modifyInfo">
          <el-form-item prop="modifyReason" label="修改原因">
            <el-input type="textarea" v-model="modifyInfo.modifyReason" style="width: 100%;"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modifyDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="modifyReasonOk">确认修改</el-button>
        </div>
      </el-dialog>
    </dev>
    
    <div>
      <el-row>
        <el-col	:span="12"><p style="text-align: right;font-weight: bold;">工厂操作清单</p></el-col>
        <el-col :span="2">
          <el-button size="mini" type="success" style="margin-top: 10%;margin-bottom: 0%;margin-left: 10%;" @click="addFactoryOperation">新增行</el-button>
        </el-col>
      </el-row>
      <el-table :data="factoryOperationList" border style="width: 100%" size="mini" show-summary>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="plateName" label="板件名称">
          <template slot-scope="scope">
            <el-input v-model="scope.row.plateName" placeholder="板件名称" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="length" label="长/高">
          <template slot-scope="scope">
            <el-input v-model="scope.row.length" placeholder="长/高" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="width" label="宽/深">
          <template slot-scope="scope">
            <el-input v-model="scope.row.width" placeholder="宽/深" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="thick" label="厚度">
          <template slot-scope="scope">
            <el-input v-model="scope.row.thick" placeholder="厚度" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.number" placeholder="数量" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="texture" label="纹理">
          <template slot-scope="scope">
            <el-input v-model="scope.row.texture" placeholder="纹理" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="board" label="板材">
          <template slot-scope="scope">
            <el-input v-model="scope.row.board" placeholder="板材" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="boardUnit" label="板材单位">
          <template slot-scope="scope">
            <el-input v-model="scope.row.boardUnit" placeholder="板材单位" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="banding" label="封边">
          <template slot-scope="scope">
            <el-input v-model="scope.row.banding" placeholder="封边" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="bandingUnit" label="封边单位">
          <template slot-scope="scope">
            <el-input v-model="scope.row.bandingUnit" placeholder="封边单位" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="processSign" label="工序签字">
          <template slot-scope="scope">
            <el-input v-model="scope.row.processSign" placeholder="工序签字" size="mini" @change="updateFactoryOperation(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="80%">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="delFactoryOperation(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
  </div>
</template>

<script>
  var token =  window.localStorage.getItem('token')
  import draggable from "vuedraggable";
export default {
  components: {
     draggable
  },
    data() {
      var numberCheck = async (rule, value, cb) => {
        var regular = /^[0-9]*$/
        if(!regular.test(value))
        {
          return cb(new Error("只能填写数字!"));
        }
      };
      var orderNoCheck = async (rule, value, cb) => {
        if(value != this.orderModifyRecord.orderNo)
        {
          
          var regular = /^[0-9a-zA-Z-_]{1,}$/
          if(!regular.test(value))
          {
            return cb(new Error("只能由字母数字和-_组成,可能包含空格或制表符!"));
          }
          
          const {data:res} = await this.$http.get('/api/s-order/order-no-check/'+value)
          if (res.code!==1){
            return cb(new Error("订单号已存在，请更换订单号！"));
          }
        }
        
      };
      var moneyCheck = async (rule, value, cb) => {
        var isNum=/^([1-9][\d]{0,7}|0)(\.[\d]{1,3})?$/;
        if(value !== undefined && value !== null && value !== "" && !isNum.test(value)) {
          return cb(new Error("请输入标准金额！"));
        }
      };
      var doubleIntCheck = async (rule, value, cb) => {
        var isNum=/^([1-9][\d]{0,7}|0)(\.[\d]{1,3})?$/;
        if(value !== undefined && value !== null && value !== "" && !isNum.test(value)) {
          return cb(new Error("请输入标准小数！"));
        }
      };
      var speModelCheck = async (rule, value, cb) => {
        var regular = /^[0-9*/]{1,}$/
        if(!regular.test(value))
        {
          return cb(new Error("只能包含数字*/"));
        }
      };
      return {
        pickerOptions: {
          disabledDate(time) {
            //设置选择今天以及今天之后的日期
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        comCode: window.localStorage.getItem("userComCode"),
        myHeaders: {Authorization: token},
        pagePermissionObj: JSON.parse(window.localStorage.getItem("pagePermission")),
        userType: window.localStorage.getItem("userType"),
        orderNo: null,
        orderInfo: {},
        partsList: [],
		factoryOperationList: [],
        
        orderImageSrcS: [],
        orderImageFileInfoList: [],
        
        pageUp: {
          path: '',
          name: ''
        },
        
        editOrderFormRules:{
          orderNo:[
            { required: true, message: '请填写订单编号', trigger: 'blur' },
            { validator: orderNoCheck, trigger: "blur" }
          ],
          deliveryDate:[
            { required: true, message: '请选择发货日期', trigger: 'blur' },
          ],
          shop:[
            { required: true, message: '订货店铺', trigger: 'blur' }
          ],
          shopPhone:[
            { required: true, message: '店铺电话', trigger: 'blur' }
          ],
          shipAddr:[
            { required: true, message: '发货地址', trigger: 'blur' }
          ],
          customerId:[
            { required: true, message: '客户ID', trigger: 'blur' }
          ],
          customerName:[
            { required: true, message: '客户姓名', trigger: 'blur' }
          ],
          customerPhone:[
            { required: true, message: '客户电话', trigger: 'blur' },
            { validator: numberCheck, trigger: "blur" }
          ],
          customerAddr:[
            { required: true, message: '收货地址', trigger: 'blur' }
          ],
          productName:[
            { required: true, message: '产品名称', trigger: 'blur' }
          ],
          colour:[
            { required: true, message: '颜色', trigger: 'blur' }
          ],
          speModel:[
            { required: true, message: '规格型号', trigger: 'blur' }
          ],
          packingRequirements:[
            { required: true, message: '请选择包装要求', trigger: 'blur' }
          ],
          logisticsMode:[
            { required: true, message: '请选择发货方式', trigger: 'blur' }
          ],
          quantity:[
            { required: true, message: '套数', trigger: 'blur' }
          ],
          totalMoney:[
            { required: true, message: '应收总额', trigger: 'blur' },
            { validator: moneyCheck, trigger: "blur" }
          ],
          prepay:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          monthBond:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          plateUnitPrice:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          cabinetCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          metalsCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          outsideProductCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          installCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          packCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          subjoinCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          factoryTotalMoney:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          cabinetArea:[
            { validator: doubleIntCheck, trigger: "blur" }
          ],
          doorPlankArea:[
            { validator: doubleIntCheck, trigger: "blur" }
          ],
          mirrorCushionArea:[
            { validator: doubleIntCheck, trigger: "blur" }
          ],
          doorCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          sheetMaterial:[
            { required: true, message: '板材材料', trigger: 'blur' }
          ],
          fillPlateArea:[
            { validator: doubleIntCheck, trigger: "blur" }
          ],
          doorTwoCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          patchPartsCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          toEstimateTheFreight:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          duty:[
            { required: true, message: '责任界定', trigger: 'blur' }
          ],
          mirrorCushionCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          unitPricePelletPlate:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          unitPriceMultilayerBoard:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          particulateCabinetCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          multiLayerCabinetCost:[
            { validator: moneyCheck, trigger: "blur" }
          ],
          particulateCabinetArea:[
            { validator: doubleIntCheck, trigger: "blur" }
          ],
          multiLayerCabinetArea:[
            { validator: doubleIntCheck, trigger: "blur" }
          ],
          patchMirrorCushionArea:[
            { validator: doubleIntCheck, trigger: "blur" }
          ],
          sreason:[
            { required: true, message: '请选填写售后原因', trigger: 'blur' }
          ],
          
        },
        modifyDialogVisible: false,
        modifyInfo: {
          modifyReason: ""
        },
        orderModifyRecord: {},
        modifyReasonFormRules:{
          modifyReason:[
            { required: true, message: '请填写修改原因', trigger: 'blur' }
          ],
        }
      };
    },
    methods: {
        onSubmit() {
          this.$refs['form'].validate(async (valid) => {
            if (valid) {
              //验证通过后显示修改原因填写框
              this.modifyDialogVisible = true;
            }
          })
          
        },
        modifyReasonOk()
        {
          this.$refs['modifyReasonForm'].validate(async (valid) => {
            if (valid) {
              //修改原因验证通过后，调取最终修改函数
              this.modifyOrder();
            }
          })
        },
        modifyOrder()
        {
          this.$refs['form'].validate(async (valid) => {
            if (valid) {
              this.orderInfo.outsideProduct = this.orderInfo.outsideProduct ? 1 : 0;
              
              if(this.pageUp.name === "售后订单报价" && this.orderInfo.orderStatus === "受理订单")
              {
                this.orderInfo.orderStatus = "报价完成"
              }
              
              // 判断是否在打开页面后订单信息有修改
              const {data:resNowOrder} = await this.$http.get('/api/s-order/getByIdOrderTable/'+this.orderInfo.id)
              if(resNowOrder.code == 1 && new Date(resNowOrder.data.updateTime).getTime() > new Date(this.orderInfo.updateTime).getTime())
              {
                // 修改过
                alert("打开页面后订单信息有修改，请在新页面的最新信息中进行修改！");
                // 打开新的修改页
                let routeData = this.$router.resolve({path: 'edit', query: { orderId: this.orderInfo.id, pageUpPath: '/sorder/list', pageUpName: '售后列表' }});
                window.open(routeData.href, '_blank');
                return;
              }
              
              // 修改更新时间并修改
              this.orderInfo.updateTime = new Date();
              const {data:res} = await this.$http.put('/api/s-order/modif-order-and-file',{ order: this.orderInfo, fileInfoList: this.orderImageFileInfoList })
              if (res.code==1)
              {
                
                this.modifyDialogVisible = false
                
                //记录修改前订单
                this.orderModifyRecord.id = null
                this.orderModifyRecord.modifyReason = this.modifyInfo.modifyReason
                this.orderModifyRecord.modifyTime = this.getNowFormatDateTime();
                this.orderModifyRecord.modifyPerson = window.localStorage.getItem('userCompellation')
                this.$http.post('/api/s-order-modify-record/create', this.orderModifyRecord)
                
                //判断订单编号是否修改
                if(this.orderModifyRecord.orderNo !== this.orderInfo.orderNo)
                {
                  //如果修改，修改原来订单编号关联的跟踪记录
                  this.$http.put('/api/s-order-tail/modifTailNewOrderNoByOldOrderNo/'+this.orderInfo.orderNo+'/'+this.orderModifyRecord.orderNo)
                }
                
                
                //拷贝订单信息方便下次记录
                this.orderModifyRecord = JSON.parse(JSON.stringify(this.orderInfo)); 
                
                //预备订单不添加跟踪
                if(this.orderInfo.orderStatus !== "预备订单")
                {
                  //添加到跟踪记录
                  let orderTail = {
                    orderNo: this.orderInfo.orderNo,
                    status: "修改原因："+this.modifyInfo.modifyReason,
                    tailTime: this.getNowFormatDateTime(),
                    operator: window.localStorage.getItem("userCompellation"),
                    }
                    
                  if(this.pageUp.name == "售后订单报价")
                  {
                    orderTail.status = "售后订单报价完成"
                  }
                    
                  const {data:res2} = await this.$http.post('/api/s-order-tail/create', orderTail)
                }
                
                if(this.pageUp.name === "售后订单报价")
                {
                  window.location.href="about:blank";
                  window.close();
                  return;
                }
                
                this.$message({
                  type: 'success',
                  message: res.msg
                });
              }else{
                this.$message({
                  message:res.msg,
                  type:'error'
                })
              }
            } else {
              this.$message({
                message:"有必填项未填写或不合法！",
                type:'error'
              })
              return false
            }
          })
        },
        async subAudit()
        {
         
          this.$confirm(this.orderInfo.orderNo+'订单提交审核, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then( async () => {
              
              const {data:res} = await this.$http.put('/api/s-order/modif', {id: this.orderInfo.id, orderStatus: "报价完成", subTime: this.getNowFormatDateTime()})
              if(res.code != 1)
              { 
                this.$message({
                  message: '提交审核失败！',
                  type: 'error'
                });
              }
              else
              {
                this.$message({
                  type: 'success',
                  message: "提交审核成功！"
                });
                this.orderInfo.orderStatus = "报价完成"
                //添加到跟踪记录
                let orderTail = {
                  orderNo: this.orderInfo.orderNo,
                  status: "提交审核",
                  tailTime: this.getNowFormatDateTime(),
                  operator: window.localStorage.getItem("userCompellation"),
                  }
                const {data:res2} = await this.$http.post('/api/s-order-tail/create', orderTail)
              }
              
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
        },
		// 新增工厂操作
		async addFactoryOperation(){
			var factoryOperationInfo = {
				orderNo:this.orderInfo.orderNo,
				plateName: '',
				length: '',
				width: '',
				thick: '',
				number: '',
				texture: '',
				board: '',
				boardUnit: 'm²',
				banding: '',
				bandingUnit:'m',
				processSign:''
			}
			const {data:res} = await this.$http.post('/api/s-order-factory-operation/save', factoryOperationInfo)
			if (res.code==1){
        this.getFactoryOperationList();
        
				console.log('********************')
				console.log(res.data)
				//this.factoryOperationList.push(factoryOperationInfo);
				this.$message({
          type: 'success',
          message: '新增行 成功！'
				});
				console.log(this.factoryOperationList)
      }else{
        this.$message({
          message: '新增行 失败！',
          type:'error'
        })
      }
    },
			deleteFactoryOperation(i){
				var info = this.factoryOperationList[i];
				this.$confirm('删除 '+info.plateName+', 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
				}).then(async () => {
					const {data:res} = await this.$http.delete('/api/s-order-factory-operation/delete/'+info.id)
					if (res.code==1){
					this.factoryOperationList = this.factoryOperationList.filter(t => t.id != info.id);
						this.$message({
							type: 'success',
						message: info.plateName+' 删除成功!'
					});
					}
				}
			).catch(() => {
					this.$message({
					type: 'info',
					message: '已取消删除'
					});
				});
			},
		async addParts(){
          var partsInfo = {
            partsCode: '8' + new Date().getTime(),
            partsName: '',
            partsNum: '',
            partsType: '',
            plateArea: '',
            partsSpe: '',
            operationNum: '',
            materialsName: '',
            cuttingMap: '',
            textarea: '',
            orderId: this.orderInfo.id
          }
          
          const {data:res} = await this.$http.post('/api/s-order-parts/create', partsInfo)
          if (res.code==1){
            this.partsList.push(res.data);
            this.$message({
              type: 'success',
              message:res.msg
            });
            
            console.log(this.partsList)
          }else{
            this.$message({
              message:res.msg,
              type:'error'
            })
          }
        },
        async editParts(i)
        {
          var partsInfo = this.partsList[i];
          const {data:res} = await this.$http.put('/api/s-order-parts/modif', partsInfo)
          if (res.code==1){
            this.$message({
              type: 'success',
              message: partsInfo.partsName+' 部件修改成功!'
            });
          }else{
            this.$message({
              type:'error',
              message:partsInfo.partsName+' 部件修改失败!'
            })
          }
          
        },
        delParts(i){
          var partsInfo = this.partsList[i];
          this.$confirm('删除 '+partsInfo.partsName+', 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
              const {data:res} = await this.$http.delete('/api/s-order-parts/delete/'+partsInfo.id)
              if (res.code==1){
                this.partsList = this.partsList.filter(t => t.id != partsInfo.id);
                this.$message({
                  type: 'success',
                  message: partsInfo.partsName+' 删除成功!'
                });
              }
            }
          ).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
        },
        orderInfoPrint(type){
          window.open("/orderprint/OrderPrint.html?orderId="+this.orderInfo.id+"&type=1", "_blank");
        },
        async getOrderInfoAndJoinInfo(orderId){
          const { data } = await this.$http.get("/api/s-order/getById/"+orderId);
          if (data.code == 1) {
            if(data.data.order != null)
            {
              this.orderInfo = data.data.order
              
              this.orderModifyRecord = JSON.parse(JSON.stringify(data.data.order))
              
              this.orderInfo.outsideProduct = this.orderInfo.outsideProduct == 1 ? true : false;
              
            }
            
            if(data.data.orderPartsList != null){this.partsList = data.data.orderPartsList}
			if(data.data.orderFactoryOperationList != null){this.factoryOperationList = data.data.orderFactoryOperationList}
            if(data.data.fileInfoList != null){
              this.orderImageFileInfoList = data.data.fileInfoList;
              //data.data.fileInfoList.forEach(f => this.orderImageSrcS.push(f.fileUrl))
            }
            
          }
        },
        getParams(){
          this.pageUp.path = this.$route.query.pageUpPath;
          this.pageUp.name = this.$route.query.pageUpName;
          var orderId = this.$route.query.orderId;
          this.getOrderInfoAndJoinInfo(orderId)
        },
        // 图片移动
        onMove({ relatedContext, draggedContext }) {
          const relatedElement = relatedContext.item;
          const draggedElement = draggedContext.item;
        },
        uploadImageSuccess(response)
        {
          if(response.code == 1)
          {
            this.orderImageFileInfoList.push(response.data)
          }
          else
          {
            this.$message({
              message:response.msg,
              type:'error'
            })
          }
        },
        delImage(fileUrl) {
          this.$confirm('删除订单中的一张图片, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            for(let i = 0; i < this.orderImageFileInfoList.length; i++)
            {
              if(this.orderImageFileInfoList[i].fileUrl == fileUrl)
              {
                this.orderImageFileInfoList.splice(i,1);
                break;
              }
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
        },
        uploadExcelSuccess(response)
        {
          if(response.code == 1)
          {
            this.orderInfo.excelFileUrl = response.data
            this.$message.success("上传成功！")
          }
          else
          {
            this.$message({
              message:response.msg,
              type:'error'
            })
          }
        },
        async getFactoryOperationList()
        {
          const { data } = await this.$http.get("/api/s-order-factory-operation/getListByOrderNo/" + this.orderInfo.orderNo);
          if (data.code == 1) {
            this.factoryOperationList = data.data;
          }
        },
        async delFactoryOperation(index, factoryOperation)
        {
          this.$confirm('确定删除 ' + factoryOperation.plateName + ' 吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then( async () => {
              const { data } = await this.$http.delete("/api/s-order-factory-operation/delete/"+factoryOperation.id)
              if(data.code == 1)
              {
                this.$message({
                  type: 'success',
                  message: data.msg
                });
                
                //this.getFactoryOperationList();
                this.factoryOperationList.splice(index, 1)
              }
              else
              {
                this.$message({
                  type: 'error',
                  message: data.msg
                });
              }
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消'
              });          
            });
        },
        async updateFactoryOperation(index, factoryOperation)
        {
          const { data } = await this.$http.post("/api/s-order-factory-operation/update", factoryOperation)
          if(data.code == 1)
          {
            this.$message({
              type: 'success',
              message: data.msg
            });
          }
          else
          {
            this.$message({
              type: 'error',
              message: data.msg
            });
          }
        }
    },
    created(){
      //解除其他页面的按键监听
      document.onkeydown = null
      
      this.getParams();
    }
  };
</script>

<style>
.text_l{
  font-size: 15px;
  margin-top: 0px;
  margin-bottom: 7px;
  font-weight: bold;
}
.text{
  font-size: 13px;
}
.text_del_image{
  font-size: 10px;
}
</style>